/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CenterChildDto } from '../../models/center-child-dto';

export interface UserCenterChildControllerFindById$Params {
  id: string;
}

export function userCenterChildControllerFindById(http: HttpClient, rootUrl: string, params: UserCenterChildControllerFindById$Params, context?: HttpContext): Observable<StrictHttpResponse<CenterChildDto>> {
  const rb = new RequestBuilder(rootUrl, userCenterChildControllerFindById.PATH, 'get');
  if (params) {
    rb.path('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<CenterChildDto>;
    })
  );
}

userCenterChildControllerFindById.PATH = '/api/center-child/user/{id}';
